<template>
<el-aside  direction="vertical" :width="sidebarWidth" class="sidebar-container">
    <SidebarInfo v-if="isShowSidebarInfo" :companyInfo="companyInfo" />
    <SidebarFreeInfo v-if="isShowSidebarFreeInfo" :companyInfo="companyInfo" />
    <div class="main-menu-bottom">
        <el-menu  :show-timeout="200" :collapse="sidebarOpened" :unique-opened="uniqueOpened"  :default-openeds="openeds" :default-active="defaultViewMenuIndex" mode="vertical">
              <template v-for="(item) in menuDataSource">
                <el-menu-item v-if="isShowMenuItem(item) && !hasChildren(item)" :key="item.path" :index="item.path" @click="handleNavigateRoute(item.isSubMenu || currentPageMode===1?'/'+item.id:item.path,item,1)">
                    <span slot="title">
                        <i :class="item.meta.icon"></i>
                        {{item.meta.title}}
                        <span v-for="(obj,index) in menuNum[item.path]" :key="index" v-if="obj.num>0" class="bakNumCommon" :class="obj.num>99?'bakNumMax':'bakNumSmall'"
                                :style="'color:'+obj.fontColor+';background:'+obj.bgColor" :title="obj.title">
                           {{obj.num}}
                        </span>
                    </span>
                </el-menu-item>
                <el-submenu v-else-if="isShowMenuItem(item)" :key="item.path" :index="item.path">
                    <template slot="title">
                        <i :class="item.meta.icon"></i>
                        <span slot="title">{{item.meta.title}}</span>
                    </template>
                    <el-menu-item v-if="isShowMenuItem(childrenItem)" v-for="(childrenItem) in item.children" :key="childrenItem.path" :index="childrenItem.path" @click="handleNavigateRoute(childrenItem.isSubMenu && currentPageMode===1?`/${childrenItem.id}` : `${item.path}/${childrenItem.path}`,childrenItem,1)">
                        <i :class="childrenItem.meta.icon"></i>
                        <span slot="title">{{childrenItem.meta.title}}</span>
                    </el-menu-item>
                </el-submenu>
            </template>
        </el-menu>
    </div>
</el-aside>
</template>

<script>
    import {mapGetters } from 'vuex';
    import { isEmpty } from 'lodash';
    import SidebarInfo from './SidebarInfo';
    import SidebarFreeInfo from './SidebarFreeInfo';
    import { getMyCompanyDetail } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';
    import { getGlobalConf } from '@/utils/grocer';

    export default {
        mixins: [ mixinsNav ],
        components: {
            SidebarInfo,
            SidebarFreeInfo
        },
        data () {
            return {
                openeds: [],
                isShowSidebarInfo: false,
                isShowSidebarFreeInfo: false,
                visible: false,
                companyInfo: {},
                defaultViewMenuIndex: this.$route.name,
                menuDataSource: this.menuData,
                uniqueOpened: true,
                currentPageMode: 0, // 0 老页面 1：新页面
                menuNum: {},
                initPath: '',
                isShowLeft: '1',
                isShowLeftStyle: 'block'
            };
        },
        watch: {
            userInfo (newVal, oldVal) {
                this.initCompany(newVal);
            },
            menuData (newVal, oldVal) {
                this.menuDataSource = newVal;
            }
        },
        props: {
            appState: {
                type: Object
            },
            menuData: {
                type: Array
            },
            userInfo: {
                type: Object
            },
            isShowMenu: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            sidebarWidth () {
                return this.appState.sidebar.opened ? '218px' : '0px';
            },
            sidebarOpened () {
                return !this.appState.sidebar.opened;
            },
            ...mapGetters([
                'menuRemindNum',
                'showLeft',
                'workPlantEntry'
            ])
        },
        created () {
            this.initCompany(this.userInfo);
        },
        methods: {
            hasChildren (menu) {
                return !isEmpty(menu.children);
            },
            isShowMenuItem (menu) {
                if (this.userInfo.switchLayoutFlg === 2) {
                    if (menu.id.indexOf('workspace') !== -1) {
                        let allWorkPlan = [];
                        for (let i = 0; i < this.workPlantEntry.length; i++) {
                            let obj = this.workPlantEntry[i];
                            allWorkPlan.push(obj.id);
                        }
                        if (allWorkPlan.join(',').indexOf(menu.id) !== -1) {
                            return true;
                        } else {
                            return !(menu.isShow === true);
                        }
                    } else {
                        return !(menu.isShow === false);
                    }
                } else {
                    return !(menu.isShow === false);
                }
            },

            handleNavigateRoute (path, item, obj) {
                if (path.substring(0, 1) !== '/') {
                    path = '/' + path;
                }
                if (item.hasOwnProperty('isTitle') && item.isTitle) {
                    return;
                }
                if (this.currentPageMode === 1) {
                    let ROUTER_BASE_PATH = getGlobalConf().routerBasePath;
                    path = ROUTER_BASE_PATH + path;
                }
                let url = sessionStorage.getItem('currentOpenUrl');
                let param = sessionStorage.getItem('openUrlParam');
                sessionStorage.removeItem('currentOpenUrl');
                sessionStorage.removeItem('openUrlParam');
                let loadSystem = sessionStorage.getItem('loadSystem');
                if (loadSystem !== 1) {
                    if (url && obj !== 1) {
                        this.$router.push({ path: url, query: JSON.parse(param) });
                    } else if (path.indexOf('workspace') !== -1) {
                        path = path.substr(0, 1) !== '/' ? '/' + path : path;
                        this.$router.push(path);
                    } else {
                        this.navigateNameTo(path, item.name);
                        // this.$router.push(path);
                    }
                } else {
                    sessionStorage.setItem('isShowLeft', '2');
                    this.$emit('isShowLeftFunc');
                    sessionStorage.setItem('loadSystem', 2);
                }
            },
            initCompany (obj) {
                this.percentage = 30;
                if (isEmpty(obj)) {
                    this.navLogin();
                } else if (obj.companyInfo) {
                    this.companyInfo = obj.companyInfo;
                    this.companyInfo.percentage = 30;
                    if (obj.expirationDate) {
                        this.companyInfo.expirationDate = obj.expirationDate;
                    }
                    if (this.companyInfo.isPay > 0) {
                        this.isShowSidebarInfo = true;
                    } else {
                        this.isShowSidebarFreeInfo = true;
                    }
                }
            },
            async refCompany () {
                let companyData = await getMyCompanyDetail();
                this.companyInfo = companyData;
            },
            async refMenu (menu, initPath, routeName) {
                this.menuDataSource = menu;
                this.initPath = initPath;
                this.uniqueOpened = true;
                this.currentPageMode = 1;
                let isNewMode = 0;
                if (menu[0].hasOwnProperty('isSubMenu') && menu[0].isSubMenu) { // 三级菜单
                    isNewMode = 0;
                } else if (menu[0].children && menu[0].children.length > 0) {
                    isNewMode = 1;// 旧二级菜单
                } else {
                    isNewMode = 2;// 新二级菜单
                }
                if (initPath) {
                    if (routeName) { // 工作台瀑布下拉跳转单独处理使用
                        this.defaultViewMenuIndex = routeName;
                    } else {
                        this.defaultViewMenuIndex = this.$route.name;
                    }
                    for (let i = 0; i < menu.length; i++) {
                        let curent = menu[i];
                        let child = curent.children;
                        if (child && child.length > 0) {
                            for (let j = 0; j < child.length; j++) {
                                let o = child[j];
                                if ('/' + o.id === initPath) {
                                    this.handleNavigateRoute(initPath, o, 1);
                                }
                            }
                        } else {
                            if (initPath.indexOf(curent.id) !== -1) {
                                this.handleNavigateRoute(initPath, curent, 1);
                            }
                        }
                    }
                } else {
                    this.defaultViewMenuIndex = isNewMode === 2 ? menu[0].path : menu[0].children[0].path;
                    let routePath = isNewMode === 1 ? '/' + menu[0].children[0].id : isNewMode === 2 ? '/' + menu[0].id : ('/' + menu[0].children[0].id);
                    if (menu[0].isTitle) {
                        this.handleNavigateRoute(routePath, menu[0].children[0], 1);
                    } else {
                        this.handleNavigateRoute(routePath, menu[0], 1);
                    }
                }
            },
            async resetRefMenu (name) { // 重设左侧菜单默认选项
                this.defaultViewMenuIndex = name;
            },
            openProcessAllMenu () {
                this.openeds = [];
                this.uniqueOpened = false;
                this.menuDataSource.forEach(menu => {
                    if (this.isShowMenuItem(menu) && menu.children) {
                        this.openeds.push(menu.path);
                    }
                });
            },
            async refMenuData (newMenuData) {
                this.menuDataSource = newMenuData;
            }
        }
    };
</script>

<style lang="less">
    .sidebar-container{
        overflow-x: hidden;
        overflow-y: hidden;
        display: flex;
        flex-direction: column;
    }

    .el-menu {
        height: 100%;
        overflow-x: hidden;
        // overflow-y: hidden;
    }
    .main-menu-bottom{
        flex: 1;
        // height: 608px;
        overflow-x: hidden;
        .el-submenu__title {
          font-size: 14px;
          color: #303133;
          padding: 0px;
          cursor: pointer;
          -webkit-transition: border-color .3s,background-color .3s,color .3s;
          transition: border-color .3s,background-color .3s,color .3s;
          box-sizing: border-box;
        }
        .el-submenu .el-menu-item {
          height: 40px;
          line-height: 40px;
          padding: 0px;
          min-width: 200px;
        }

        .el-menu-item, .el-submenu__title {
          height: 50px;
          line-height: 50px;
          position: relative;
          -webkit-box-sizing: border-box;
          white-space: nowrap;
          list-style: none;
          .bakNumCommon{
              display:inline-block;
              font-size:12px;
              height:16px;
              border-radius:9px;
              margin-left:4px;
              line-height: 16px;
              text-align:center;
              padding:1.5px;
              margin-top:-2px
          }
          .bakNumMax{
              width: 24px;
          }
          .bakNumSmall{
              width: 16px;
          }
          .bakNumCommon:hover{
              background: rgb(0, 206, 209) !important;
          }
      }
      .el-menu--inline{
        overflow: hidden;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar/Sidebar.vue